import { IVariable } from "../../interfaces/variable.interface";

const ActionTypes = {
  ADD_SELECTED_SUBTREE_VARIABLES: '[Variables] Add Selected Subtree Variables',
  REMOVE_SELECTED_SUBTREE_VARIABLES: '[Variables] Remove Selected Subtree Variables',
  RESET_SELECTED_SUBTREE_VARIABLES: '[Vareiables] Reset Selected Subtree Variables',
}

export class AddSelectedSubtreeVariables {
  static type = ActionTypes.ADD_SELECTED_SUBTREE_VARIABLES;

  constructor(public payload: string[]) {}
}

export class RemoveSelectedSubtreeVariables {
  static type = ActionTypes.REMOVE_SELECTED_SUBTREE_VARIABLES;

  constructor(public payload: string[]) {}
}

export class ResetSelectedSubtreeVariables {
  static type = ActionTypes.RESET_SELECTED_SUBTREE_VARIABLES;
}